/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsSearch = {
  init: function($section) {
    // Add settings from schema to current object
    window.PXUTheme.jsSearch = $.extend(this, window.PXUTheme.getSectionData($section));

    // Initialize search overlay functionality
    this.initSearchOverlay();

    // If breadcrumbs enabled and basic pagination is set, call breadcrumbs object
    if (this.enable_breadcrumb && this.pagination_type == 'basic_pagination') {
      window.PXUTheme.breadcrumbs.init(this.number_of_pages);
    }
  },

  initSearchOverlay: function() {
    const searchTrigger = document.querySelector('[data-show-search-trigger]');
    const searchOverlay = document.querySelector('.search-overlay');
    const closeButton = document.querySelector('.search-overlay__close');
    const searchInput = document.querySelector('.search-input');

    if (searchTrigger && searchOverlay) {
      // Open search overlay
      searchTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        searchOverlay.classList.add('is-active');
        // Focus the search input when overlay opens
        if (searchInput) {
          setTimeout(() => {
            searchInput.focus();
          }, 100);
        }
      });

      // Close search overlay when close button is clicked
      if (closeButton) {
        closeButton.addEventListener('click', (e) => {
          e.preventDefault();
          searchOverlay.classList.remove('is-active');
        });
      }

      // Close search overlay when ESC key is pressed
      document.addEventListener('keyup', (e) => {
        if (e.key === 'Escape' && searchOverlay.classList.contains('is-active')) {
          searchOverlay.classList.remove('is-active');
        }
      });
    }
  },

  unload: function($target) {
    window.PXUTheme.breadcrumbs.unload();
    
    // Clean up event listeners
    const searchTrigger = document.querySelector('[data-show-search-trigger]');
    const closeButton = document.querySelector('.search-overlay__close');
    
    if (searchTrigger) {
      searchTrigger.removeEventListener('click');
    }
    if (closeButton) {
      closeButton.removeEventListener('click');
    }
  }
}


/******/ })()
;